export const CoinIcon = ({ size = 14, className = "" }) => (
  <img src="/assets/coin-single.png" alt="coins" style={{ width: size, height: size }} className={`inline-block object-contain shrink-0 ${className}`} />
);

export const RubyIcon = ({ size = 14, className = "" }) => (
  <img src="/assets/ruby-gem.png" alt="rubies" style={{ width: size, height: size }} className={`inline-block object-contain shrink-0 ${className}`} />
);
